export const TOGGLE_TOOLBAR = "TOGGLE_TOOLBAR";

export const toggleToolbar = () => {
  return { type: TOGGLE_TOOLBAR };
};
